<template>
  <div>
    <CRow>
      <CCol col="12">
        <CCard>
          <CCardHeader>
            <div>
              <strong v-if="status_form==0">{{ $t('add_product') }}</strong>
              <strong v-if="status_form!=0">{{ $t('edit_product') }}</strong>
            </div>
            <div>
              <CButton v-if="status_form==0" @click="login()" type="submit" ref="submit_form" size="sm"
                       color="primary">
                <CIcon name="cil-check-circle"/>
                {{ $t('add_product') }}
              </CButton>
              <CButton v-if="status_form!=0" @click="login()" type="submit" ref="submit_form" size="sm"
                       color="primary">
                <CIcon name="cil-check-circle"/>
                {{ $t('update') }}
              </CButton>
              <CButton color="info" class="mr-1" size="sm"  @click="go_to_product()">
               <CIcon size="sm" name="eye"/>
              </CButton>
              <CButton color="info" class="mr-1" size="sm"  @click="copy_product_link()">
                <CIcon size="sm" name="cil-clone"/>
              </CButton>
            </div>

          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="6 col-sm-4">
                <CInput
                    v-model="title"
                    class="required"

                    :label="$t('product_title')"
                    vertical
                />
              </CCol>
              <CCol col="6 col-sm-4">
                <CInput
                    v-model="code"
                    class="required"

                    :label="$t('product_code')"
                />
              </CCol>
              <CCol col="6 col-sm-4"
                    v-show="false"
              >
                <CInput
                    class="required"
                    v-model="seo_title"
                    label="متا عنوان"
                />
                <SeoProgress :min_perfect="50" :max_perfect="60" :string="seo_title"/>

              </CCol>
              <CCol col="6 col-sm-4"
                    v-show="false"
              >
                <CInput
                    v-model="keyword"

                    label="کلید واژه"
                />
              </CCol>
              <CCol col="6 col-sm-4"
                    v-show="false"
              >
                <CInput
                    label="آدرس جایگزین"

                    v-model="favorite_url"/>
              </CCol>
              <CCol col="6 col-sm-4"
                    v-show="false"
              >
                <CSelect
                    :options="[{label:'محصول فیزیکی',value:1},{label:'محصول دانلودی',value:2}]"
                    :value.sync="product_type"

                    label="نوع محصول"

                />

              </CCol>
            </CRow>
            <CRow>

            </CRow>
            <CRow>
              <CCol col="12">
                {{ $t('short_summary') }}

              </CCol>

              <CCol col="12">

<!--                <editorjs v-if="loaded_page"-->
<!--                          editor_id="add_new_editor"-->
<!--                          key="add_new_editor"-->
<!--                          :first_content.sync="content_json"-->
<!--                          :content_json.sync="content_json"-->
<!--                          :content_text.sync="content_text"-->
<!--                          :content_html.sync="content_html"-->
<!--                />-->
<CTextarea
  v-model="content_json"
  />
              </CCol>
              <CCol col="12">
                {{ $t('full_summary') }}
                <editorjs v-if="loaded_page"
                          editor_id="add_new_editor_full"
                          key="add_new_editor_full"

                          :first_content.sync="content_json_full"
                          :content_json.sync="content_json_full"
                          :content_text.sync="content_text_full"
                          :content_html.sync="content_html_full"
                />


              </CCol>

            </CRow>
            <hr>

            <CCol col="12"
                  v-show="false"
            >
              <CTextarea
                  v-model="seo_summary"
                  rows="8"
                  class="required"

                  label="سئو توضیحات"

              />
              <SeoProgress :min_perfect="120" :max_perfect="150" :string="seo_summary"/>

            </CCol>

          </CCardBody>
        </CCard>
        <CCard>
          <CCardHeader>
            {{ $t('pricing') }}
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="6 col-sm-4">
                <CInputCurrency
                    v-model="product_price"
                    class="required"
                    :label="$t('product_price')"

                />

              </CCol>
              <CCol col="6 col-sm-4">
                <CInputCurrency
                    v-model="product_stock"
                    class="required"

                    :label="$t('stock')"

                />

              </CCol>
              <CCol col="6 col-sm-4"
                    v-show="false"
              >
                <CSelect
                    label="ارز"

                    :options="currency_items"
                    :value.sync="selected_currency"/>

              </CCol>
              <CCol col="6 col-sm-4"
                    v-show="false"
              >
                <CInput
                    v-model="order_point"
                    label="نقطه سفارش"

                />
              </CCol>
              <CCol col="6 col-sm-4">
                <CInputCurrency
                    v-model="product_off_price"
                    :label="$t('offer_price')"

                />

              </CCol>
              <CCol col="6 col-sm-4">
                <div>{{ $t('expire_off_price') }}</div>
                <date-picker
                    v-model="product_off_price_date"
                    type="datetime"

                    display-format="jYYYY/jMM/jDD HH:mm"
                    format="YYYY-MM-DD HH:mm"
                    inputFormat="YYYY-MM-DD HH:mm"
                    :description="$t('empty_for_no_expire')"

                />

              </CCol>

            </CRow>
          </CCardBody>
        </CCard>
        <CCard>
          <CCardHeader>

          </CCardHeader>
          <CCardBody>
            <CRow >

              <CCol col="6 col-sm-4">
                <div class="control_wrapper">
                  <div class="required">
                    <label>{{ $t('product_category') }}</label>
                  </div>
                  <treeselect
                      v-model="value_category"
                      :multiple="true"
                      :flat="true"
                      :normalizer="normalizer_category"
                      :options="options_category"
                      :placeholder="$t('select_product_caegory')"
                  />

                </div>

              </CCol>
              <CCol col="6 col-sm-4">
                <div class="control_wrapper">
                  <treeselect
                      v-model="value_label"
                      :multiple="false"
                      :normalizer="normalizer_category"
                      :options="options_label"
                      :placeholder="$t('select_product_label')"
                  />

                </div>

              </CCol>
              <CCol col="12 col-sm-6">

                <ImageSelector :label="$t('image_gallery')"
                               v-if="show_gallery"
                               :media_id.sync="gallery"
                               :multiple="true"
                               default_archive="products"
                               :preview-image="previewImage"
                />
              </CCol>
            </CRow>

          </CCardBody>
          <CCardFooter>
            <CButton v-if="status_form==0" @click="login()" type="submit" ref="submit_form" size="sm"
                     color="primary">
              <CIcon name="cil-check-circle"/>
              {{ $t('add_product') }}
            </CButton>
            <CButton v-if="status_form!=0" @click="login()" type="submit" ref="submit_form" size="sm"
                     color="primary">
              <CIcon name="cil-check-circle"/>
              {{ $t('update') }}
            </CButton>
          </CCardFooter>

        </CCard>

      </CCol>
    </CRow>


  </div>

</template>

<script>
import axios from "axios";

import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload)
import VueUploadMultipleImage from 'vue-upload-multiple-image'


import Vue from "vue";

import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'


import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import editorjs from "@/views/includes/editorjs.vue";
// import  Readability from "@/plugins/readability";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 200)
}

export default {
  name: 'Login',
  components: {
    editorjs,
    Treeselect,
    VueUploadMultipleImage,
  },
  data() {

    return {
      loaded_page: false,
      content_json: "",
      content_text: '',
      content_html: '',

      content_json_full: {},
      content_text_full: '',
      content_html_full: '',

      previewImage: null,
      gallery: [],
      product_type: 1,
      value_label: null,
      options_label: [],
      options_brand: [],
      value_category: [],
      related_products: [],
      property_items: [],
      language_items: [],
      currency_items: [],
      selected_currency: 0,
      property_group_items: [],
      product_property_values: [],
      fields_properties: [
        {key: 'group', label: 'گروه', _style: 'width:10%'},
        {key: 'property', label: 'ویژگی', _style: 'width:90%'},
      ],
      fields_properties_items: [
        {key: 'title', label: 'عنوان', _style: 'width:20%;display:none'},
        {key: 'value', label: 'مقدار', _style: 'width:80%;display:none'},
      ],
      options_category: [],
      normalizer_category(node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children,
        }
      },
      normalizer_brand(node) {
        return {
          id: node.id,
          label: node.title.title,
        }
      },

      normalizer_tags(node) {
        return {
          id: node.title,
          label: node.title,
        }
      },

      editorConfig: {
        extraPlugins: [],
        language: 'fa'
        // The configuration of the editor.
      },
      title: '',
      code: '',
      favorite_url: '',
      keyword: '',
      seo_title: '',
      summary: '',
      seo_summary: '',
      product_price: '',
      order_point: '0',
      product_stock: '',
      product_off_price: '',
      product_off_price_date: '',
      tags: '',

      show_gallery: true,
      status_form: 0,

    }
  },
  mounted() {
    this.loaded_page= false

    console.log("mounted called")
var self = this
    this.get_categories();
    this.get_product_labels();
    this.get_currencies();
    this.get_languages();
    if (self.$route.params.product_id != null) {
      self.status_form = self.$route.params.product_id;
      self.get_post_info();
    } else if (self.$route.params.clone_product_id != null) {
      self.status_form = self.$route.params.clone_product_id;
      self.get_post_info();
    } else {
      setTimeout(function (){
        self.loaded_page = true

      },300)
    }
  }, watch: {

    'seo_summary': function () {
      // console.log("seo changed",Readability.getScore(this.seo_summary))
    }
  },
  methods: {
    go_to_product() {
      window.open(localStorage.getItem("site_url")+"/product/"+this.favorite_url)
    },
    copy_product_link() {
      var textArea = document.createElement("textarea");
      textArea.value = localStorage.getItem("site_url")+"/product/"+this.favorite_url;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();


        // Select the text field
      textArea.select();
      textArea.setSelectionRange(0, 99999); // For mobile devices
        // Copy the text inside the text field
        navigator.clipboard.writeText(textArea.value);
      this.$toast.open({
        message: "کپی شد!!!",
        type: 'success',
        // all of other options may go here
      });
      document.body.removeChild(textArea);

    },

    load_tags({action, searchQuery, callback}) {

      if (action === ASYNC_SEARCH) {
        simulateAsyncOperation(() => {
          let options;
          var formData = new FormData();
          formData.append('search', searchQuery);
          axios.post('/api/admin/product/search_product_tags', formData, {show_pros:false}).then(function (response) {
            options = response.data;
            callback(null, options);
          })
              .catch(function (error) {
                console.log(error);
              });

        })
      }
    },

    editImage(formData, index, fileList) {
      console.log('edit data', formData, index, fileList)
    },

    get_categories() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/product/get_categories_with_children', formData, {}).then(function (response) {
        var content_cats = response.data;
        self.options_category = content_cats.orders;
      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_product_labels() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/product/get_label', formData, {}).then(function (response) {
        var content_cats = response.data;
        self.options_label = content_cats.orders;
      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_currencies() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/site/get_currencies', formData, {}).then(function (response) {
        var content_cats = response.data;
        self.currency_items = self.sort_array([], content_cats.data, "id", "title");
        self.selected_currency = content_cats.default_unit;
      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_languages() {
      var self = this;
      var formData = new FormData();
      axios.post('/api/admin/site/get_languages', formData, {}).then(function (response) {
        var content_cats = response.data;
        self.language_items = content_cats.data;
      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_post_info() {
      var self = this;
      var formData = new FormData();
      formData.append("product_id", self.status_form)
      axios.post('/api/admin/product/get_product_info', formData, {}).then(function (response) {
        var post_data = response.data;
        self.value_category=[]
        post_data.post.categories.forEach((val) => {
          self.value_category.push(val.category_id);
        });

        self.code = post_data.post.code;
        self.product_type = post_data.post.type;
        self.favorite_url = post_data.post.title.slug;

        self.title = post_data.post.title.title;
        self.content_json = post_data.post.title.short_description;
        self.content_json_full = post_data.post.title.description;
        self.seo_summary = post_data.post.title.meta_description;
        self.seo_title = post_data.post.title.seo_title;
        self.keyword = post_data.post.title.keyword;

        if (post_data.post.label) {
          self.value_label = post_data.post.label.label_id;
        }
        if (post_data.post.price_no != null) {
          self.product_price = post_data.post.price_no.price;
          self.product_stock = post_data.post.price_no.stock;
          self.product_off_price = post_data.post.price_no.off_price;
          self.order_point = post_data.post.price_no.order_point;
          self.selected_currency = post_data.post.price_no.currency_id;
          self.product_off_price_date = post_data.post.price_no.off_expire;
        }
        self.gallery=[]
        post_data.post.gallery.forEach((val2) => {
          self.gallery.push(val2.image_id);
        });
        self.loaded_page = true
        if (self.$route.params.clone_product_id != null) {
          self.status_form = 0
        }
      }).catch(function (error) {
        console.log(error);
      });


    },


    login() {

      let self = this;
      const formData = new FormData()
      let url;
      if (self.status_form == 0) {
        url = "/api/admin/product/insert_product";
      } else {
        url = "/api/admin/product/update_product";
        formData.append('product_id', this.status_form)

      }
      for (var i = 0; i < this.gallery.length; i++) {

          formData.append('post_images[]', this.gallery[i])

      }
      formData.append('property_group_items', JSON.stringify(this.property_group_items));
      formData.append('product_type', this.product_type);
      formData.append('cat_list', this.value_category);
      formData.append('tags', this.value_tags);
      formData.append('label_id', this.value_label);
      formData.append('name', this.title);
      formData.append('url', this.favorite_url);
      formData.append('code', this.code);
      // formData.append('text', JSON.stringify(this.content_json));
      formData.append('text', this.content_json);
      formData.append('full_text', JSON.stringify(this.content_json_full));
      formData.append('meta_desc', this.seo_summary);
      formData.append('meta_title', this.seo_title);
      formData.append('keyword', this.keyword);
      formData.append('price', this.product_price);
      formData.append('product_stock', this.product_stock);
      formData.append('order_point', this.order_point);
      formData.append('product_off_price', this.product_off_price);
      formData.append('product_off_price_date', this.product_off_price_date);
      formData.append('selected_currency', this.selected_currency);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        if (self.status_form == 0) {
          self.name = '';
          self.mobile = '';
          self.email = '';
          self.description = '';
          self.password = '';
          self.product_price = '';
          self.product_stock = '';
          self.product_off_price = '';
          self.order_point = 0;
          self.product_off_price_date = '';
          if(res.data.error==0){
            self.$router.push({path:"/dashboard/products/edit/" + res.data.id})
          }
        }else{
          self.get_post_info()
        }

      }).catch(function (error) {

        console.log(error);
      });

    }
  }
}


</script>
<style>

</style>
